import FirmInfo from './FirmInfo';

export default FirmInfo;
